import React, { useCallback, useContext, useRef, useState } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import ListingContext from '../../../../../../providers/Listing/Listing.context';
import api from 'api';
import PlusIcon from 'icons/Plus.icon';
import { useTranslation } from 'react-i18next';
import {
  DOCUMENT_FILES,
  SINGLE_FILE_MAX_SIZE_MB,
  SINGLE_FILE_MAX_SIZE_DIRECT_UPLOAD,
} from 'data/global';

import './UploadNda.styles.scss';

const LISTING_NDA = 'listingNDA';

type UploadNdaProps = {
  className?: string;
};

const UploadNda: React.FC<UploadNdaProps> = (props) => {
  const { className } = props;

  const [isUploading, setIsUploading] = useState(false);

  const { popError, popServerError } = useContext(PopNotificationsContext);
  const { isSuperAdmin } = useContext(CurrentUserContext);
  const { areActionsDisabled, listing, dealRoom, setDealRoom } =
    useContext(ListingContext);

  const { envelopeTemplateId } = listing || {};

  const { _id: dealRoomId, listingNDA } = dealRoom || {};

  const fileInputRef = useRef<HTMLInputElement>();

  const classes = classNames('upload-nda', className);

  const { t } = useTranslation();

  const uploadNdaFile = useCallback(
    async (file: File) => {
      try {
        setIsUploading(true);

        const { dealRoom } = await api.dealRoom.uploadDealFile(
          file,
          LISTING_NDA,
          dealRoomId,
        );

        setDealRoom((prev) => ({ ...prev, ...dealRoom }));
      } catch (e) {
        popServerError(e);
      } finally {
        setIsUploading(false);
      }
    },
    [dealRoomId, popServerError, setDealRoom],
  );

  if (isSuperAdmin || listingNDA || envelopeTemplateId) return null;

  return (
    <div className={classes}>
      <Button
        variant="outline"
        icon={PlusIcon}
        disabled={areActionsDisabled || isUploading}
        {...(!areActionsDisabled && {
          onClick: () => fileInputRef?.current.click(),
        })}
      >
        {t('uploadNdaToDataRoom')}
      </Button>

      <input
        ref={fileInputRef}
        type="file"
        value={[]}
        accept={DOCUMENT_FILES.join(', ')}
        style={{ display: 'none' }}
        onChange={(ev) => {
          const file = Array.from(ev.target.files)[0];

          if (file) {
            if (file.size > SINGLE_FILE_MAX_SIZE_DIRECT_UPLOAD) {
              popError(t('ndaTooLarge', { size: SINGLE_FILE_MAX_SIZE_MB }));
              return;
            }

            uploadNdaFile(file);
          }
        }}
      />
    </div>
  );
};

export default UploadNda;
